import { SearchSource } from '@carvana/merch-contracts';
import { useEffect, useContext, useMemo } from 'react';
import ModalContext from '~/context/srp/ModalContext';
import { useHeliosQuali } from '~/context/srp/QualiContext';
import SearchEventsDataContext from '~/context/srp/SearchEventsDataContext';
import { loadItemFromLocalStorage } from '~/utilities/localStorage';
import useIsInQualiExperiment from './useIsInQualiExperiment';

export default function useHeliosQualiModal() {
  const isInQualiExperiment = useIsInQualiExperiment();
  const { searchSource } = useContext(SearchEventsDataContext);
  const { isFilterModalOpen } = useContext(ModalContext);
  const { captureQualiAction, qualiCriteria } = useHeliosQuali();

  useEffect(() => {
    switch (searchSource) {
      case SearchSource.SuggestedFilter:
        captureQualiAction('suggestedFilterClicked');
        break;
      case SearchSource.TagRemoved:
        captureQualiAction('filterRemoved');
        break;
      case SearchSource.Facet:
        captureQualiAction('filterMenuInteractedWith');
        break;
      default:
        break;
    }
  }, [captureQualiAction, searchSource]);

  const hasMetCriteriaForQuali = useMemo(
    (): boolean =>
      isInQualiExperiment
        ? qualiCriteria.filterMenuInteractedWith &&
          qualiCriteria.filterRemoved &&
          qualiCriteria.suggestedFilterClicked &&
          Boolean(loadItemFromLocalStorage('srp/hasVisitedVDP'))
        : false,
    [
      isInQualiExperiment,
      qualiCriteria.filterMenuInteractedWith,
      qualiCriteria.filterRemoved,
      qualiCriteria.suggestedFilterClicked
    ]
  );

  const canTriggerQuali = useMemo(
    () =>
      (searchSource === SearchSource.SuggestedFilter ||
        searchSource === SearchSource.Facet ||
        searchSource === SearchSource.ApplyFilters ||
        searchSource === SearchSource.TagRemoved) &&
      !isFilterModalOpen,
    [isFilterModalOpen, searchSource]
  );

  return hasMetCriteriaForQuali && canTriggerQuali;
}
